<template>
  <div>
    <Header></Header>
    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div id="hot-post" class="row hot-post">
          <div class="col-md-8 hot-post-left">
            <!-- post -->
            <div class="post post-thumb big">
              <a class="post-img" :href="`#/post/${spotlightPosts0.slug}`">
                <img
                  :src="spotlightPosts0.image"
                  :alt="spotlightPosts0.title"
                />
              </a>
              <div class="post-body">
                <div class="post-category flex-start">
                  <a
                    class="mr-1"
                    v-for="cat in spotlightPosts0.category"
                    :key="cat.id"
                    :href="`#/busca?category=${cat.title}`"
                    >{{ cat.title }}</a
                  >
                </div>
                <h3 class="post-title title-lg">
                  <a :href="`#/post/${spotlightPosts0.slug}`">{{
                    spotlightPosts0.title
                  }}</a>
                </h3>
                <ul class="post-meta">
                  <li>
                    <a :href="`#/autor/${spotlightPosts0.user.id}`">{{
                      spotlightPosts0.user.name
                    }}</a>
                  </li>
                  <li>
                    {{ spotlightPosts0.timestamp | moment("DD/MM/YYYY") }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- /post -->
          </div>
          <div class="col-md-4 hot-post-right">
            <!-- post -->
            <div class="post post-thumb">
              <a class="post-img" :href="`#/post/${spotlightPosts1.slug}`">
                <img
                  :src="spotlightPosts1.image"
                  :alt="spotlightPosts1.title"
                />
              </a>
              <div class="post-body">
                <h3 class="post-title">
                  <a :href="`#/post/${spotlightPosts1.slug}`">{{
                    spotlightPosts1.title
                  }}</a>
                </h3>
                <ul class="post-meta">
                  <li>
                    <a :href="`#/autor/${spotlightPosts1.user.id}`">{{
                      spotlightPosts1.user.name
                    }}</a>
                  </li>
                  <li>
                    {{ spotlightPosts1.timestamp | moment("DD/MM/YYYY") }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- /post -->

            <!-- post -->
            <div class="post post-thumb margin-t-small-mobile">
              <a class="post-img" :href="`#/post/${spotlightPosts2.slug}`">
                <img
                  :src="spotlightPosts2.image"
                  :alt="spotlightPosts2.title"
                />
              </a>
              <div class="post-body">
                <h3 class="post-title">
                  <a :href="`#/post/${spotlightPosts2.slug}`">{{
                    spotlightPosts2.title
                  }}</a>
                </h3>
                <ul class="post-meta">
                  <li>
                    <a :href="`#/autor/${spotlightPosts2.user.id}`">{{
                      spotlightPosts2.user.name
                    }}</a>
                  </li>
                  <li>
                    {{ spotlightPosts2.timestamp | moment("DD/MM/YYYY") }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- /post -->
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <div class="section month" v-show="monthPosts.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="section-title">
              <h2 class="title">Destaques de {{ currentMonth }}</h2>
            </div>

            <div class="month-slider-holder mt-1">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <article
                    v-for="post in monthPosts"
                    :key="post.id"
                    class="swiper-slide month-card"
                  >
                    <img
                      :src="post.image"
                      alt="thumb"
                      @click="$router.push(`/post/${post.slug}`)"
                      style="cursor:pointer;"
                    />
                    <h1
                      @click="$router.push(`/post/${post.slug}`)"
                      style="cursor:pointer;"
                    >
                      {{ post.title }}
                    </h1>
                    <ul class="post-meta">
                      <li>
                        <a :href="`#/autor/${post.user.id}`">{{
                          post.user.name
                        }}</a>
                      </li>
                      <li>
                        {{ post.timestamp | moment("DD/MM/YYYY") }}
                      </li>
                    </ul>
                  </article>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>

                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION -->
    <div class="section" style="padding-top:0;">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div
              class="flex-column-center section-title gap col-md6"
              style="padding:0 15px;"
            >
              <h2 class="title">Realização:</h2>
              <div class="sponsor-holder">
                <a
                  href="http://smcc.com.br/home"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src="../assets/images/patrocinio/smcc.jpg"
                    class="patrocinio"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-8">
            <!-- row -->
            <div class="row">
              <div class="col-md-12">
                <div class="section-title">
                  <h2 class="title">Últimas publicações</h2>
                </div>
              </div>
              <!-- post -->
              <div
                class="post post-row"
                v-for="post in latestPosts"
                :key="post.id"
              >
                <a class="post-img" :href="'/#/post/' + post.slug">
                  <img :src="post.image" :alt="post.title" />
                </a>
                <div class="post-body">
                  <div class="post-category">
                    <a
                      class="mr-1"
                      v-for="tag in post.tag.slice(0, 4)"
                      :key="tag.id"
                      :href="`#/busca?tag=${tag.title}`"
                      >{{ tag.title }}</a
                    >
                  </div>
                  <h3 class="post-title">
                    <a :href="'/#/post/' + post.slug">{{ post.title }}</a>
                  </h3>
                  <ul class="post-meta">
                    <li>
                      <a :href="`#/autor/${post.user.id}`">{{
                        post.user.name
                      }}</a>
                    </li>
                    <li>{{ post.timestamp | moment("DD/MM/YYYY") }}</li>
                  </ul>
                  <p
                    class="post-card-description"
                    v-html="post.description"
                  ></p>
                </div>
              </div>
              <!-- /post -->

              <div class="section-row loadmore text-center">
                <a href="#/busca" class="primary-button">Ver Mais</a>
              </div>
            </div>
            <!-- /row -->
          </div>
          <div class="col-md-4">
            <Newsletter></Newsletter>

            <!-- post widget -->
            <div class="aside-widget">
              <div class="section-title">
                <h2 class="title">Mais visualizados</h2>
              </div>
              <!-- post -->
              <div
                class="post post-widget"
                v-for="post in mostViewedPosts"
                :key="post.id"
              >
                <a class="post-img" :href="'/#/post/' + post.slug">
                  <img :src="post.image" :alt="post.title" />
                </a>
                <div class="post-body">
                  <div class="post-category">
                    <a :href="`#/busca?category=${post.category[0].title}`">{{
                      post.category[0].title
                    }}</a>
                  </div>
                  <h3 class="post-title">
                    <a :href="'/#/post/' + post.slug">{{ post.title }}</a>
                  </h3>
                </div>
              </div>
              <!-- /post -->
            </div>
            <!-- /post widget -->
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-4">
            <div class="section-title">
              <h2 class="title">Especialidades Clínicas</h2>
            </div>
            <!-- post -->
            <div
              v-for="post in column1Posts"
              :key="post.id"
              class="post post-widget"
            >
              <a class="post-img" :href="`#/post/${post.slug}`">
                <img :src="post.image" :alt="post.title" />
              </a>
              <div class="post-body">
                <div class="post-category">
                  <a :href="`#/busca?category=${post.category[0].title}`">{{
                    post.category[0].title
                  }}</a>
                </div>
                <h3 class="post-title">
                  <a :href="`#/post/${post.slug}`">{{ post.title }}</a>
                </h3>
              </div>
            </div>
            <!-- /post -->
          </div>
          <div class="col-md-4">
            <div class="section-title">
              <h2 class="title">Especialidades Cirúrgicas</h2>
            </div>

            <!-- post -->
            <div
              v-for="post in column2Posts"
              :key="post.id"
              class="post post-widget"
            >
              <a class="post-img" :href="`#/post/${post.slug}`">
                <img :src="post.image" :alt="post.title" />
              </a>
              <div class="post-body">
                <div class="post-category">
                  <a :href="`#/busca?category=${post.category[0].title}`">{{
                    post.category[0].title
                  }}</a>
                </div>
                <h3 class="post-title">
                  <a :href="`#/post/${post.slug}`">{{ post.title }}</a>
                </h3>
              </div>
            </div>
            <!-- /post -->
          </div>
          <div class="col-md-4">
            <div class="section-title">
              <h2 class="title">Bem-Estar</h2>
            </div>

            <!-- post -->
            <div
              v-for="post in column3Posts"
              :key="post.id"
              class="post post-widget"
            >
              <a class="post-img" :href="`#/post/${post.slug}`">
                <img :src="post.image" :alt="post.title" />
              </a>
              <div class="post-body">
                <div class="post-category">
                  <a :href="`#/busca?category=${post.category[0].title}`">{{
                    post.category[0].title
                  }}</a>
                </div>
                <h3 class="post-title">
                  <a :href="`#/post/${post.slug}`">{{ post.title }}</a>
                </h3>
              </div>
            </div>
            <!-- /post -->
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>

<script>
import http from "@/http";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import Swiper from "swiper";

export default {
  name: "Home",
  data() {
    return {
      page: 0,
      quantity: 4,
      monthPosts: [],
      latestPosts: [],
      morePosts: [],
      mostViewedPosts: [],
      allPostsLoaded: false,
      loading: false,
      spotlightPosts0: {
        id: 0,
        category: [],
        user: {
          id: 0
        }
      },
      spotlightPosts1: {
        id: 0,
        category: [],
        user: {
          id: 0
        }
      },
      spotlightPosts2: {
        id: 0,
        category: [],
        user: {
          id: 0
        }
      },
      column1Posts: [],
      column2Posts: [],
      column3Posts: [],
      currentMonth: ""
    };
  },
  components: {
    Header,
    Footer,
    Newsletter
  },
  created() {
    let months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];
    this.currentMonth = months[new Date().getMonth()];
    http
      .get("post/home")
      .then(response => {
        this.spotlightPosts0 = response.data.spotlight[0];
        this.spotlightPosts1 = response.data.spotlight[1];
        this.spotlightPosts2 = response.data.spotlight[2];

        this.monthPosts = response.data.monthPosts;

        this.mostViewedPosts = response.data.mostViewed;

        this.latestPosts = response.data.lastPosts;

        this.column1Posts = response.data.tagColumn1;
        this.column2Posts = response.data.tagColumn2;
        this.column3Posts = response.data.tagColumn3;

        this.allPostsLoaded = true;

        localStorage.posts = JSON.stringify(response.data);

        this.monthPostsSliderInit();
      })
      .catch(err => {
        this.loadSpotlightPosts();
      })
      .finally(() => {
        this.loading = false;
      });
  },
  mounted() {
    // new Swiper("#patrocinioSlider", {
    //   freeMode: true,
    //   slidesPerView: 4,
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev"
    //   },
    //   breakpoints: {
    //     1024: {
    //       slidesPerView: 3
    //     },
    //     800: {
    //       slidesPerView: 2
    //     },
    //     640: {
    //       slidesPerView: 1
    //     }
    //   }
    // });
  },
  methods: {
    monthPostsSliderInit() {
      setTimeout(() => {
        new Swiper(".swiper-container", {
          // autoplay: {
          //   delay: 4000,
          //   disableOnInteraction: true
          // },
          watchOverflow: true,
          slidesPerView: 3,
          spaceBetween: 20,
          freeMode: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 3
            },
            800: {
              slidesPerView: 2,
              spaceBetween: 0
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
              freeMode: false
            }
          }
        });
      }, 150);
    },
    loadSpotlightPosts() {
      http
        .get("post/search?spotlight=true")
        .then(response => {
          this.spotlightPosts0 = response.data.list[0];
          this.spotlightPosts1 = response.data.list[1];
          this.spotlightPosts2 = response.data.list[2];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadMostViewedPosts();
        });
    },
    loadMostViewedPosts() {
      http
        .get("post/search?page=0&take=4&order=MOST VIEWED")
        .then(response => {
          this.mostViewedPosts = response.data.list;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadLatestPosts();
        });
    },
    loadLatestPosts() {
      if (!this.allPostsLoaded) {
        http
          .get(`post?page=${this.page}&take=${this.quantity}`)
          .then(response => {
            if (this.page == 0) {
              this.latestPosts = response.data.list;
            } else {
              this.morePosts = [...this.morePosts, ...response.data];
            }
            if (response.data.length >= this.quantity) {
              this.page++;
            } else {
              this.allPostsLoaded = true;
            }
            if (this.page > 0) {
              this.quantity = 8;
            } else {
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(response => {
            this.loading = false;
            this.loadTagPosts();
          });
      }
    },
    loadTagPosts() {
      http
        .get("post/search?take=3&tag=Especialidades Clínicas")
        .then(response => {
          this.column1Posts = response.data.list;
        });

      http
        .get("post/search?take=3&tag=Especialidades Cirúrgicas")
        .then(response => {
          this.column2Posts = response.data.list;
        });

      http.get("post/search?take=3&tag=Bem-Estar").then(response => {
        this.column3Posts = response.data.list;
      });
    },
    enviarContato() {
      this.visibleButton = false;
      http.post("/contato", this.contato).then(
        res => {
          this.contato.nome = "";
          this.contato.email = "";
          this.contato.celular = "";
          this.contato.mensagem = "";
          this.visibleButton = true;
          this.showTxtEnviado = true;
        },
        () => {
          this.visibleButton = true;
        }
      );
    }
  }
};
</script>
<style>
.section.month {
  padding-top: 10px;
}
.month-slider-holder,
.month-slider-holder .swiper-container {
  padding-bottom: 30px;
}

.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 0px;
}

.swiper-button-next,
.swiper-button-prev {
  z-index: 11 !important;
  outline: none !important;
}

.swiper-button-prev {
  left: 0 !important;
}

.swiper-button-next {
  right: 0 !important;
}

.swiper-container::before,
.swiper-container::after {
  position: absolute;
  content: "";
  width: 50px;
  height: 170px;
  top: 0;
  left: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), transparent);
  z-index: 10;
}

.swiper-container::after {
  left: initial;
  right: 0;
  background: linear-gradient(-90deg, rgba(255, 255, 255, 0.9), transparent);
}

.month-card {
  position: relative;
  width: 100%;
  max-width: 340px;
  height: 170px !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  overflow: hidden;
  box-shadow: 0 2px 10px -1px rgba(0, 0, 0, 0.3);
  margin-left: 15px;
}

.month-card img {
  position: absolute;
  min-height: 100%;
  max-height: 135%;
  top: 50%;
  left: 50%;
  right: 0;
  margin: 0 auto;
  transition: transform 0.6s ease;
  transform: translate3d(-50%, -50%, 0);
}

.month-card:hover > img {
  transform: translate3d(-50%, -50%, 0) scale(1.2);
}

.month-card h1 {
  position: relative;
  display: block;
  width: 100%;
  color: #fff;
  transition: color 0.2s ease;
  font-size: 1em;
  padding: 18px 15px 0 15px;
  max-height: calc(2em + 22px);
  overflow: hidden;
  margin: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 42%, transparent 100%);
  box-sizing: border-box !important;
}

.month-card h1:hover {
  color: #43bbee;
}

.month-card .post-meta {
  position: relative;
}

.month-card .post-meta {
  position: relative;
  width: 100%;
  padding: 10px 15px 12px 15px;
  background-color: rgba(0, 0, 0, 0.7);
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.month-card .post-meta li,
.month-card .post-meta li a {
  color: #fff;
}
@media (max-width: 680px) {
  .hot-post-right {
    margin-top: 15px;
  }
  .margin-t-small-mobile {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue